import { Button } from '@/components/ui/button';
import { Check, ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { CourseLesson } from '@/types/courses';

interface PlayerControlsProps {
  isCompleted: boolean;
  previousLesson: CourseLesson | null;
  nextLesson: CourseLesson | null;
  onToggleComplete: () => void;
  onPrevious: () => void;
  onNext: () => void;
  onCompleteAndNext: () => void;
}

export function PlayerControls({
  isCompleted,
  previousLesson,
  nextLesson,
  onToggleComplete,
  onPrevious,
  onNext,
  onCompleteAndNext,
}: PlayerControlsProps) {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-2 border-b border-gray-100 dark:border-gray-800 pb-4">
      <button
        onClick={onToggleComplete}
        className="flex items-center gap-2 group text-sm font-medium transition-colors hover:text-gray-900 dark:hover:text-white text-gray-600 dark:text-gray-400"
      >
        <div
          className={cn(
            'w-5 h-5 rounded-full border flex items-center justify-center transition-colors',
            isCompleted
              ? 'bg-green-500 border-green-500 text-white'
              : 'border-gray-300 dark:border-gray-600 group-hover:border-green-500'
          )}
        >
          {isCompleted && <Check className="w-3.5 h-3.5" />}
        </div>
        <span>{isCompleted ? 'Completed' : 'Mark as Complete'}</span>
      </button>

      <div className="flex items-center gap-3 w-full sm:w-auto">
        <Button
          variant="outline"
          onClick={onPrevious}
          disabled={!previousLesson}
          className="flex-1 sm:flex-none"
        >
          <ChevronLeft className="h-4 w-4 mr-1" />
          Previous
        </Button>
        {nextLesson ? (
          <>
            <Button
              variant="outline"
              onClick={onNext}
              className="flex-1 sm:flex-none"
            >
              Next
              <ChevronRight className="h-4 w-4 ml-1" />
            </Button>
            <Button
              onClick={onCompleteAndNext}
              className="bg-[#F37022] hover:bg-[#E36012] text-white flex-1 sm:flex-none whitespace-nowrap"
            >
              <span className="hidden sm:inline">Complete & Continue</span>
              <span className="sm:hidden">Complete</span>
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </>
        ) : (
          <Button
            onClick={onToggleComplete}
            className="bg-green-600 hover:bg-green-700 text-white flex-1 sm:flex-none"
          >
            Finish Course
          </Button>
        )}
      </div>
    </div>
  );
}
